<template>
  <va-dropdown
    class="profile-dropdown"
    v-model="isShown"
    boundary-body
  >
    <span
      class="profile-dropdown__anchor" slot="anchor"
      :style="{color: this.$themes.primary}"
    >
      <slot/>
      <va-icon
        style="color:white!important"
        class="pa-1"
        :name="`fa ${isShown ? 'fa-angle-up' :'fa-angle-down'}`"
      />
    </span>
    <div class="profile-dropdown__content">
      <b-row class="pa-2">
        <b-col>
          <span class="profile-dropdown__item" style="font-size:14px!important; padding-bottom: 12px; padding-top: 4px;" @click="$router.push('/userview/'+appUser._id+'?type=admin')">
            Profile
          </span>
          <span class="profile-dropdown__item" style="font-size:14px!important; padding-bottom: 12px;" @click="changepass()">
            Change Password
          </span>
          <span class="profile-dropdown__item" style="font-size:14px!important; padding-bottom: 4px;" @click="handlelogout()">
            Logout
          </span>
        </b-col>
      </b-row>
    </div>
  </va-dropdown>
</template>

<script>
import store from '../../../../../store'

export default {
  props: ['appUser'],
  name: 'profile-section',
  data () {
    return {
      isShown: false,
    }
  },
  methods: {
    changepass () {
      this.$router.push('/changepassword')
    },
    handlelogout () {
      store.commit('logoutUser')
      localStorage.removeItem('token')
      this.$router.push({ name: 'login' })
    },
  },
}
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__anchor {
    color: $vue-green;
  }
  .va-dropdown-popper__anchor {
    display: flex;
    justify-content: flex-end;
  }
  &__content {
    background-color: blue;
    box-shadow: $gray-box-shadow;
    border-radius: .5rem;
    width: 12rem;
  }
  &__item {
    display: block;
    color: $vue-darkest-blue;

    &:hover, &:active {
      color: $vue-green;
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
